import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "vant/lib/index.css";
import "@/assets/global.scss";
import "@/assets/font/iconfont.css";

import { initVantComponents, initDataRanger } from "./install-plugins";

Vue.config.productionTip = false;

initVantComponents();
initDataRanger();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
